<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
    <div class="flex flex-col gap-1">
        <label for="date-filter" class="text-sm font-bold text-cs-gray-lv-5">Date Range</label>

        <div class="flex items-center w-full md:w-[235px]">
            <VueDatePicker id="date-filter" v-model="dateRange" :range="true" :class="[
                'h-full focus:outline-none focus:ring-2 focus:ring-blue-500 ',
                { 'ring-2 ring-blue-500': isFocused }
            ]" format="yyyy/MM/dd" :enable-time-picker="false" placeholder="yyyy/mm/dd - yyyy/mm/dd"
                @focus="isFocused = true" @blur="isFocused = false" @update:model-value="onDateRangeChange" />
        </div>
    </div>
</template>

<script>

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    name: 'DateRangePicker',
    components: { VueDatePicker },
    data() {
        return {
            dateRange: [],
            isFocused: false
        }
    },
    created() {
        this.prefillDateRangeFromUrl()
    },
    methods: {
        prefillDateRangeFromUrl() {
            const params = new URLSearchParams(window.location.search)
            const startDateParam = params.get('created_at_gteq')
            const endDateParam = params.get('created_at_lteq')

            if (startDateParam && endDateParam) {
                const startDate = new Date(startDateParam)
                const endDate = new Date(endDateParam)

                if (!isNaN(startDate) && !isNaN(endDate)) {
                    this.dateRange = [startDate, endDate]
                }
            }
        },
        onDateRangeChange(newDateRange) {
            this.dateRange = newDateRange

            if (!newDateRange || newDateRange.length === 0) {
                this.clearDateFilter()
            } else if (newDateRange && newDateRange.length === 2) {
                this.submitDateRange()
            }
        },
        clearDateFilter() {
            const params = new URLSearchParams(window.location.search)
            params.delete('created_at_gteq')
            params.delete('created_at_lteq')
            window.location.search = params.toString()
        },
        submitDateRange() {
            const params = new URLSearchParams(window.location.search)

            if (this.dateRange && this.dateRange.length === 2) {
                const startDate = new Date(this.dateRange[0]).toISOString().split('T')[0]
                const endDate = new Date(this.dateRange[1]).toISOString().split('T')[0]

                params.set('created_at_gteq', startDate)
                params.set('created_at_lteq', endDate)
            } else {
                params.delete('created_at_gteq')
                params.delete('created_at_lteq')
            }

            window.location.search = params.toString()
        }
    }
}
</script>

<style>
.dp__input {
    border-radius: 40px !important;
    border: 1px solid #B1B1B4 !important;
    background-color: #F9F9F9 !important;
    padding: 12px 30px 12px 32px !important;
}

.dp__input_icon {
    color: #302EA0 !important;
}
</style>
